import React from "react";
import NotificationLayer from "./NotificationLayer";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";

const NotificationPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Notifications" />

        {/* RoleAccessLayer */}
        <NotificationLayer />

      </MasterLayout>

    </>
  );
};

export default NotificationPage; 
